import { render } from "./AdCard.vue?vue&type=template&id=1a61afe4&scoped=true"
import script from "./AdCard.vue?vue&type=script&lang=js"
export * from "./AdCard.vue?vue&type=script&lang=js"

import "./AdCard.vue?vue&type=style&index=0&id=1a61afe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a61afe4"]])

export default __exports__